import React from 'react';
import Overlay from '../../partials/white_overlay';

const Roster = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Roster</h2>
                <p>Rosters can be changed up to the start of the first game. No changes or substitutions to rosters will be allowed after the start of a team's first game. All rosters are final at the start of the team's first game.</p>
                <p>The age group a team will be registered is based on the oldest player on the roster. If 5 players are five and the sixth player is six, the team must play in the U7 age group.</p>
                <p>Tournament t-shirts will be ordered on Tuesday, based on the roster at that time. Therefore, it is recommended that all initial rosters be completed by 10 am Tuesday morning. Rosters can still be updated after that point, until the start of the first game.</p>
                <p>SIX (6) is the maximum number of players on a team; with THREE (3) field players at one time.</p>
                <p>A player may play for one team only during an event. Dual rostering for a single event is not allowed. A player can play for multiple teams during the tour season but not during the same event.</p>
                <p>There are no goalkeepers in 3v3 soccer. Substitutes may occur at any dead ball situation, but players must get the referee’s attention to enter and exit at the half-field mark only.</p>
            </div>
        </div>
    );
}

export default Roster;



// WEBPACK FOOTER //
// ./src/components/rules/partials/roster.js